/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { Eligibility, InputData } from '../_common/data/input-data';
import { Path, Progress } from  "../_common/constant/page-const";
import { Setup5Validation } from './setup_5.validator';
import { ItemList } from '../_common/constant/item-list';
import { ProgressService } from 'src/refresh/service/progress-service';
import { ViewportScroller } from '@angular/common';

@Component({ 
      selector: 'setup_5',
      templateUrl: './setup_5.component.html',
      styleUrls: ['./setup_5.component.less']
})
export class Setup5Component extends FormBaseComponent implements OnInit {

      public error_invalidListedParentCount: string;
      public error_invalidCertifyingParentCount: string;
      eligibility : Eligibility;

      constructor( protected router: Router ,
                   public timerService:TimerService,
                   protected progress:ProgressService,
                   public data:InputData,
                   public items:ItemList,
                   public viewportScroller: ViewportScroller ) {

            super(router,timerService);  
            super.setNextPage(Path.AboutTheChildMain,Path.Setup4);
            super.setValidator(new Setup5Validation(this,Progress.Eligibility));
            this.eligibility = data.eligibility;

            InputData.currentPageIdx = 7;
            if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
      }

      public ngOnInit() {
      	 if ( super.forwardNext(InputData.currentPageIdx) ) return;
      }

      displayCertifyingParentQuestion(){
            return this.eligibility.isUnableToCertify == 'Y' 
                  && this.eligibility.listedParentCount > 2;
      }

      setCertifyingParentCount(){

            if ( this.eligibility.isCustodyOtherThanParent == 'Y' ) {
                 this.eligibility.certifyingParentCount = 0;
                 return;
            }
                 
            if ( this.eligibility.isUnableToCertify != 'Y' ) {
                 this.eligibility.certifyingParentCount = this.eligibility.listedParentCount;
                 return;
            }
       
            if(this.eligibility.listedParentCount == 1)
                  this.eligibility.certifyingParentCount = 0;
            else 
            if(this.eligibility.listedParentCount == 2)
                  this.eligibility.certifyingParentCount = 1;
      }

      public onNextClick(): boolean { 

            if ( super.onNextClick() ) {
                 this.setCertifyingParentCount();
                 this.data.setParentCount(this.eligibility.listedParentCount);
            }
            return true;
      }
  
}